import { AxiosError } from "axios";

import { getUserInternalAccessToken } from "@/api/access-token-backoffice";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IWorkflow } from "@/interfaces/workflow.interface";
import { apiBackofficeT2b } from "@/lib/axios";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

const baseWorkflowsUrl = "v1/workflow";

export async function getWorkflowBackoffice(
  pagination: RequestPagination
): Promise<PaginatedResponse<IWorkflow>> {
  try {
    // Get internal access token (simula o Next.js Route Handler)
    const { accessToken } = await getUserInternalAccessToken();

    const paginationQuery = buildPaginationQuery(pagination);
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };

    const response = await apiBackofficeT2b.get(`${baseWorkflowsUrl}?${paginationQuery}`, config);

    return response.data as PaginatedResponse<IWorkflow>;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Failed to fetch workflows");
    }
    throw new Error("Failed to fetch workflows");
  }
}
